import getLegCallingPointIndexByNameAndTime from "../utils/TSI/getLegCallingPointIndexByNameAndTime";
import useJourneyLeg from "./useJourneyLeg";
import useTSILeg from "./useTSILeg";
const useTSIDestinationCallingPointIndex = (legId) => {
  var _a;
  const leg = useJourneyLeg(legId);
  const tsiLeg = useTSILeg(legId);
  const destination = getLegCallingPointIndexByNameAndTime("arrive", leg.localArriveAt, (_a = leg.destination) == null ? void 0 : _a.name, tsiLeg);
  return destination;
};
var useTSIDestinationCallingPointIndex_default = useTSIDestinationCallingPointIndex;
export {
  useTSIDestinationCallingPointIndex_default as default
};
